import { PartyTypeModal } from '../../party-type/modal/party-type-modal';

export class CategoryTypeModel {
  id: number;
  key: String;
  label: String;
  description: String;
  partyType: any;

  //for Angular Use
  partyString: String;
}
